import React from 'react';
import {map as _map} from "lodash";
import Select from "../../state/Select";
import {connect} from '@gisatcz/ptr-state';

const Popup = (props) => {
    return (
        <div>
            {_map(props.attributes, (item) => {
                return <div key={item.key}><b>{item.name || item.key}</b>: {item.value} {item.unit && `(${item.unit})`}</div>
            })}
        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        attributes: Select.specific.eo4sdDrrInsarMyanmar20.getDataForPopup(state, ownProps.data)
    };
};

export default connect(mapStateToProps)(Popup);